import { Link, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useFlag } from '@unleash/proxy-client-react';
import { useEffect, useState } from 'react';
import { Banner } from '../components/Banner';

const BANNER_LOCAL_STORAGE_KEY = 'sessionIdMigrationBanner';

const dates = ['2025-06-01', '2025-06-15', '2025-07-01', '2025-07-15'];
const getNextDueDate = (date: string) => {
  const nextDate = dates.find((d) => dayjs(d).isAfter(dayjs(date), 'day'));

  return nextDate ? dayjs(nextDate) : null;
};

export const SessionIdMigrationBanner = () => {
  const featureFlagEnabled = useFlag('useSessionIdMigrationBanner');
  const [show, setShow] = useState(false);

  const onClose = () => {
    setShow(false);

    localStorage.setItem(
      BANNER_LOCAL_STORAGE_KEY,
      dayjs().format('YYYY-MM-DD'),
    );
  };

  useEffect(() => {
    const bannerKey = localStorage.getItem(BANNER_LOCAL_STORAGE_KEY);
    if (!bannerKey) {
      setShow(true);
      return;
    }

    const nextDueDate = getNextDueDate(bannerKey);

    // If there's no next due date (stored date is after all reminder dates),
    // we should stop showing the banner permanently
    if (!nextDueDate) {
      setShow(false);
      return;
    }

    const todayIsPastOrSameAsNextDueDate =
      dayjs().isSame(nextDueDate) || dayjs().isAfter(nextDueDate);

    const canShow = todayIsPastOrSameAsNextDueDate && featureFlagEnabled;

    setShow(canShow);
  }, [featureFlagEnabled]);

  if (!show) return null;

  return (
    <Banner type="info" onClose={onClose}>
      <Text>
        Reminder! Adopt{' '}
        <Link
          href="https://support.tryfinch.com/hc/en-us/articles/30635805701908-Connection-Session-ID-Migration-Guide"
          textDecoration="underline"
        >
          Session ID
        </Link>{' '}
        by July 31, 2025 to avoid service interruptions.
      </Text>
    </Banner>
  );
};
